import React, { FC, useEffect } from "react";
import IconClose from "../../../images/icon-close.png";
import * as S from './styled';
import Image from "next/image";

export const isEscEvent = (evt: KeyboardEvent) => evt.key === "Escape" || evt.key === "Esc";

type Props = {
    onClose: () => void;
    children: React.ReactNode;
    isBigHeightModal?: boolean;
};

const Modal: FC<Props> = ({ onClose, children, isBigHeightModal }) => {

    useEffect(() => {
        const handleEscKeyDown = (evt: KeyboardEvent) => {
            if (!isEscEvent(evt)) {
                return;
            }
            onClose();
        };
        document.addEventListener("keydown", handleEscKeyDown);

        return () => {
            document.removeEventListener("keydown", handleEscKeyDown);
        };
    }, [onClose]);

    useEffect(() => {
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

        return (
            <S.ModalOverlay onClick={onClose}>
                <S.ModalWrap isBigHeightModal={isBigHeightModal} onClick={(evt) => evt.stopPropagation()}>
                    <S.ButtonClose onClick={onClose}>
                        <S.IconCloseWrap>
                            <Image src={IconClose} alt={'close'} width={20} height={20}/>
                        </S.IconCloseWrap>
                    </S.ButtonClose>
                    {children}
                </S.ModalWrap>
            </S.ModalOverlay>
        );
}

export default Modal;
